<template>
  <div id="a">
    <div class="num">
      {{count}}
    </div>
    <b-form-textarea :class="classes" v-model="data" :rows="rows" v-bind:placeholder="placeholder" :disabled="disabled" :maxlength="maxlength" v-if="type == 'textarea'">
    </b-form-textarea>
  </div>
</template>
<style scoped>
  .num {
    margin-bottom: -30px;
    margin-top: 2px;
    margin-right: 2px;
    float: right;
    text-align: center;
    padding: 2px 4px;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 1);
    color: #ffffff;
    opacity: 0.2;
    font-size: 10px;
  }
</style>
<script>
export default {
  name: 'CountTextArea',
  components: {
  },
  props: {
    type: {
      required: false,
      default: 'textarea'
    },
    value: {
      required: false,
      default: ''
    },
    rows: {
      required: false,
      default: 5
    },
    placeholder: {
      required: false,
      default: ''
    },
    classes: {
      required: false,
      default: 'form-control border-radius-4px'
    },
    disabled: {
      required: false,
      default: false
    },
    maxlength: {
      required: false,
      default: 255
    }
  },
  data: function () {
    return {
      data: '',
      count: this.maxlength
    }
  },
  methods: {
  },
  created () {
    this.data = this._.cloneDeep(this.value)
  },
  watch: {
    data: function () {
      if (this.data.length > this.maxlength) {
        this.data = this.data.substring(0, this.maxlength)
      }
      this.count = this.maxlength - this.data.length
      this.$emit('input', this.data)
      this.$emit('change', this.data)
    },
    value: function () {
      this.data = this._.cloneDeep(this.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Partials/CountTextArea.vue